var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-lg-3 pl-1" },
      [
        _c("ListCompanyDivisions", {
          attrs: {
            label: "",
            name: "divisionId",
            placeholder: "Division",
            small: ""
          },
          on: { input: _vm.onServerChange },
          model: {
            value: _vm.serverConfig.divisionId,
            callback: function($$v) {
              _vm.$set(_vm.serverConfig, "divisionId", $$v)
            },
            expression: "serverConfig.divisionId"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-lg-3 pl-1" },
      [
        _c("ListCompanyUnits", {
          attrs: {
            label: "",
            name: "unitId",
            placeholder: "Unidad",
            "parent-value": _vm.serverConfig.divisionId,
            small: ""
          },
          on: { input: _vm.onServerChange },
          model: {
            value: _vm.serverConfig.unitId,
            callback: function($$v) {
              _vm.$set(_vm.serverConfig, "unitId", $$v)
            },
            expression: "serverConfig.unitId"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-lg-4 pl-1" },
      [
        _c("ListUser", {
          attrs: {
            label: "",
            name: "targetUserId",
            small: "",
            placeholder: "Usuario"
          },
          on: { input: _vm.onServerChange },
          model: {
            value: _vm.serverConfig.targetUserId,
            callback: function($$v) {
              _vm.$set(_vm.serverConfig, "targetUserId", $$v)
            },
            expression: "serverConfig.targetUserId"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-lg-2 pl-1" },
      [
        _c(
          "b-form-group",
          { staticClass: "mb-3" },
          [
            _c("b-form-input", {
              attrs: {
                id: "search",
                placeholder: "Busqueda",
                name: "search",
                size: "sm"
              },
              on: { input: _vm.onTheFlyChange },
              model: {
                value: _vm.onTheFlyConfig.name,
                callback: function($$v) {
                  _vm.$set(_vm.onTheFlyConfig, "name", $$v)
                },
                expression: "onTheFlyConfig.name"
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }